import { enUS as e } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/locale/en-US.js";
const n = {
  name: "en-US",
  locale: e
}, a = n;
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/locales/date/enUS.js
// module id = 1713
// module chunks = 67